/* assets/tt-add-categories.js
   Technician Tees — Add Categories page logic
   Production: no console output, no debug readouts
*/

(function () {
  'use strict';

  function normalizeClientSlug(raw) {
    return String(raw || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '');
  }

  function qs(sel) {
    return document.querySelector(sel);
  }

  function qsa(sel) {
    return Array.prototype.slice.call(document.querySelectorAll(sel));
  }

  function setClientErrorVisible(isVisible) {
    const errorBox = qs('.tt-client-error');
    if (!errorBox) return;
    errorBox.style.display = isVisible ? 'block' : 'none';
  }

  function setHiddenValue(id, value) {
    const el = document.getElementById(id);
    if (!el) return;
    el.value = value;
  }

  function getClientFromQuery() {
    const params = new URLSearchParams(window.location.search);
    return normalizeClientSlug(params.get('client'));
  }

  async function fetchExistingForClient(client) {
    const url = window.TT_CLIENT_CATS_URL;
    if (!url) return [];

    try {
      const res = await fetch(url + '?v=' + Date.now(), { cache: 'no-store' });
      if (!res.ok) return [];

      const data = await res.json();
      return Array.isArray(data[client]) ? data[client] : [];
    } catch (e) {
      return [];
    }
  }

  function syncSelectedUI() {
    const tiles = qsa('.tt-addcats-tile');
    tiles.forEach(function (tile) {
      const cb = tile.querySelector('input[type="checkbox"]');
      const checked = !!(cb && cb.checked);
      tile.classList.toggle('is-selected', checked);
    });
  }

  function applyTileVisibility(existingKeys) {
    const tiles = qsa('[data-cat-key]');
    let visibleCount = 0;

    tiles.forEach(function (tile) {
      const key = (tile.getAttribute('data-cat-key') || '').trim();

      if (existingKeys.includes(key)) {
        tile.classList.add('tt-is-hidden');

        const cb = tile.querySelector('input[type="checkbox"]');
        if (cb) cb.checked = false;
        tile.classList.remove('is-selected');
      } else {
        tile.classList.remove('tt-is-hidden');
        visibleCount++;
      }
    });

    const grid = document.getElementById('ttAddCatsGrid');
    const msg = document.getElementById('ttAllPresentMsg');

    if (visibleCount === 0) {
      if (grid) grid.style.display = 'none';
      if (msg) msg.style.display = 'block';
    } else {
      if (grid) grid.style.display = '';
      if (msg) msg.style.display = 'none';
    }
  }

  function buildSelectedBody(client) {
    const visibleTiles = qsa('.tt-addcats-tile').filter(function (tile) {
      return !tile.classList.contains('tt-is-hidden');
    });

    const selectedLabels = [];

    visibleTiles.forEach(function (tile) {
      const cb = tile.querySelector('input[type="checkbox"]');
      if (!cb || !cb.checked) return;

      const label = String(cb.value || '').trim();
      if (label) selectedLabels.push(label);
    });

    const lines = [];
    lines.push('Category Add Request');
    lines.push('Client: ' + client);
    lines.push('Requested categories:');
    if (selectedLabels.length) {
      selectedLabels.forEach(function (label) {
        lines.push('- ' + label);
      });
    } else {
      lines.push('- (none selected)');
    }

    return lines.join('\n');
  }

  function wireForm(client) {
    const form = document.getElementById('ttAddCatsForm');
    if (!form) return;

    const bodyInput = document.getElementById('ttAddCatsBody');
    const clientInput = document.getElementById('ttContactClient');

    function refreshBody() {
      const body = buildSelectedBody(client);
      if (bodyInput) bodyInput.value = body;
      return body;
    }

    refreshBody();
    syncSelectedUI();

    form.addEventListener('change', function (e) {
      if (e.target && e.target.classList.contains('tt-addcats-check')) {
        syncSelectedUI();
        refreshBody();
      }
    });

    form.addEventListener('submit', function (e) {
      const body = refreshBody();
      if (clientInput) clientInput.value = client;

      if (!body || body.indexOf('- ') === -1) {
        e.preventDefault();
        alert('Please select at least one category to request.');
      }
    });
  }

  async function run() {
    const client = getClientFromQuery();

    if (!client) {
      setClientErrorVisible(true);
      return;
    }

    setClientErrorVisible(false);
    document.body.classList.add('tt-has-client');

    setHiddenValue('ttClientSlugInput', client);
    setHiddenValue('ttContactClient', client);

    const existing = Array.isArray(window.TT_EXISTING_CATS)
  ? window.TT_EXISTING_CATS
  : await fetchExistingForClient(client);

    applyTileVisibility(existing);

    wireForm(client);

    const bodyInput = document.getElementById('ttAddCatsBody');
    if (bodyInput) bodyInput.value = buildSelectedBody(client);
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('pageshow', run);
})();
